import {BigDecimal, Money, VatTypeEnum} from '@dms/api/shared';

export type Price = {
  /**
   * Price without VAT
   */
  withoutVat: Money | null;
  /**
   * Price with VAT
   */
  withVat: Money | null;
  /**
   * VAT
   */
  vat: Money | null;
  /**
   * Type of VAT
   */
  vatType: VatTypeEnum | null;
  /**
   * VAT rate percentage
   */
  vatRate: BigDecimal | null;
};
